var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"head-container"},[_c('div',{ref:"chinaMap",staticStyle:{"width":"100%","height":"1000px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }